import { render, staticRenderFns } from "./RightsTreeNode.vue?vue&type=template&id=2bf2576e&scoped=true"
import script from "./RightsTreeNode.vue?vue&type=script&lang=js"
export * from "./RightsTreeNode.vue?vue&type=script&lang=js"
import style0 from "./RightsTreeNode.vue?vue&type=style&index=0&id=2bf2576e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2576e",
  null
  
)

export default component.exports